import React from 'react';
import { Box, Grid } from '@material-ui/core';

import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';

export default function TraitAccordion(props) {
  const { t } = useTranslation();

  return (
    <Grid
      container
      direction={props.isDesktop ? 'row' : 'column'}
      justify="center"
      spacing={2}
    >
      <Grid item xs={props.isDesktop ? 6 : 12} px={2}>
        <Grid item xs={12}>
          <Box
            justifyContent="center"
            display="flex"
            style={{
              textTransform: 'uppercase',
              textAlign: 'center',
            }}
          >
            <Typography variant="h5">
              {t('reporting.traitDetails.whatDoesThisMeanSectionTitle')}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <div>
            {props.meaning && (
              <Typography variant="body1" style={{ fontSize: '16px' }}>
                {props.meaning
                  ? props.meaning
                  : props.explanation
                  ? props.explanation[0]
                  : ''}
              </Typography>
            )}
            {props.explanation && props.explanation.length !== 0 && (
              <Typography variant="body1" style={{ fontSize: '16px' }}>
                {props.explanation[0]}
              </Typography>
            )}
            {props.explanation && props.explanation.length > 1 && (
              <Typography variant="body1" style={{ fontSize: '16px' }}>
                {props.explanation[1]}
              </Typography>
            )}
          </div>
        </Grid>
      </Grid>
      <Grid item xs={props.isDesktop ? 6 : 12}>
        <Grid item xs={12}>
          <Box
            display="flex"
            justifyContent="center"
            style={{
              textTransform: 'uppercase',
              textAlign: 'center',
            }}
          >
            <Typography variant="h5">
              {t('reporting.traitDetails.traitDescriptionSectionTitle')}
            </Typography>
          </Box>
        </Grid>
        <Grid item>
          <Typography variant="body1" style={{ fontSize: '16px' }}>
            {props.description}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
